/* Let category title links navigate while the existing summary control keeps its dropdown behavior. */
document.addEventListener('click', function (event) {
  if (event.target.closest('[data-brand-category-link]')) event.stopPropagation();
}, true);
